import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import { api } from "../lib/api";
import { useI18n } from "../context/I18nContext";

export const SoldArchive = () => {
  const { t } = useI18n();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/assets", { params: { status: "sold" } }).then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  if (items.length === 0) return null;

  return (
    <section id="sold" data-testid="sold-archive" className="bg-navy grain relative py-24 md:py-36 px-6 lg:px-10 overflow-hidden">
      <div className="max-w-[1400px] mx-auto relative z-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16 gap-6">
          <div className="max-w-2xl">
            <p className="font-sans text-gold text-[11px] tracking-luxury uppercase mb-5">{t("sold.label")}</p>
            <h2 className="font-serif text-white text-4xl md:text-6xl leading-tight">
              {t("sold.hA")} <span className="italic text-gold">{t("sold.hB")}</span>
            </h2>
          </div>
          <p className="font-sans text-white/50 text-sm max-w-sm leading-relaxed">{t("sold.note")}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {items.map((a, i) => (
            <motion.div key={a.id} initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.8, delay: i * 0.1 }} data-testid={`sold-card-${i}`} className="group">
              <div className="relative h-[300px] overflow-hidden rounded-xl mb-5 border border-white/10">
                <img src={a.image_url} alt="Sold asset" className="w-full h-full object-cover scale-110" style={{ filter: "blur(14px) brightness(0.55)" }} />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="flex flex-col items-center gap-3">
                    <Lock className="w-6 h-6 text-gold" strokeWidth={1.4} />
                    <span className="font-serif italic text-white text-3xl">{t("sold.stamp")}</span>
                  </div>
                </div>
                <span className="absolute top-4 left-4 bg-gold text-navy text-[10px] tracking-wide-lux uppercase px-3 py-1.5 rounded font-sans">{t(`cat.${a.category}`)}</span>
              </div>
              <h3 className="font-serif text-white text-2xl mb-3">{a.type}</h3>
              <div className="flex flex-wrap gap-x-6 gap-y-2">
                {(a.specs || []).map((s) => (
                  <div key={s.label} className="flex flex-col">
                    <span className="font-sans text-white/40 text-[10px] tracking-wide-lux uppercase">{s.label}</span>
                    <span className="font-sans text-gold text-sm">{s.value}</span>
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
